<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">达人审核</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>达人状态：</label>
          <el-select v-model="status" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in statusArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>推荐状态：</label>
          <el-select v-model="recommend" placeholder="Select" style="width: 8em">
            <el-option v-for="item in recommendArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>新人展示：</label>
          <el-select v-model="newUserShow" placeholder="Select" style="width: 8em">
            <el-option v-for="item in newUserShowArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>关注类型：</label>
          <el-select v-model="focusState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in focusStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)"/>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)" :type="1"/>
          <el-button type="success" @click="batchUpdate(2)" v-loading="bitchPassLoading">批量通过</el-button>
          <el-button type="danger"  @click="batchUpdate(3)" v-loading="bitchRejectLoading">批量不通过</el-button>
          <el-button v-if="recommend == -1"  :disabled="true">推荐状态</el-button>
          <el-button v-if="recommend == 1" type="danger"  @click="batchUpdateRe(0)" v-loading="updateReLoading">取消推荐</el-button>
          <el-button v-if="recommend == 0" type="success"  @click="batchUpdateRe(1)" v-loading="updateReLoading">开启推荐</el-button>
          <el-button v-if="newUserShow == -1" :disabled="true">新人展示</el-button>
          <el-button v-if="newUserShow == 1" type="danger"  @click="batchUpdateNew(0)" v-loading="updateNewLoading">隐藏新人展示</el-button>
          <el-button v-if="newUserShow == 0" type="success"  @click="batchUpdateNew(1)" v-loading="updateNewLoading">开启新人展示</el-button>
          <el-button type="success" @click="batchUpdateFocus(1)" v-loading="updateFocusLoading">设为关注</el-button>
          <el-button type="danger"  @click="batchUpdateFocus(0)" v-loading="updateFocusLoading">取消关注</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="updateTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1" class-name="cursor">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="224">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,birth"/>
              <p>身高：{{ scope.row.height }}cm</p>
              <p>现居城市：{{ scope.row.city }}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="身份认证总状态" v-if="checkColList.indexOf('身份认证总状态') > -1">
            <template #default="scope">
              <p>{{scope.row.identityAuth.overallAuthState == 0 ? '未提交' : scope.row.identityAuth.overallAuthState == 1 ? '待审核' : scope.row.identityAuth.overallAuthState == 2 ? '审核通过' :  scope.row.identityAuth.overallAuthState == 3 ? '审核不通过' : '--'}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="达人状态" v-if="checkColList.indexOf('达人状态') > -1">
            <template #default="scope">
              <p>{{scope.row.status == 1 ? '待审核' : scope.row.status == 2 ? '已通过' :  scope.row.status == 3 ? '不通过' : '--'}}</p>
              <p>{{scope.row.focusState == 0 ? '未关注' : scope.row.focusState == 1 ? '关注中' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="推荐状态" v-if="checkColList.indexOf('推荐状态') > -1">
            <template #default="scope">
              <p>{{scope.row.recommend == 0 ? '未推荐' : scope.row.recommend == 1 ? '已推荐' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="新人展示" v-if="checkColList.indexOf('新人展示') > -1">
            <template #default="scope">
              <p>{{scope.row.newUserShow == 0 ? '已隐藏' : scope.row.newUserShow == 1 ? '已展示' :  ''}}</p>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getApplyPageList, updateApplyNewUserShow, updateApplyRecommend, updateTalentFcousState
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/dialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import ImgUpload from "@/views/single/components/release/ImgUpload";
import ReleaseDialog from "@/views/single/components/release/ReleaseDialog";
import UpdateApplyStateDialog from "@/views/talent/components/UpdateApplyStateDialog";
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import ApplySearchInfoDialog from "@/views/talent/components/ApplySearchInfoDialog";

export default {
  name: "TalentApply",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog, SearchUidOrPhone },
  data() {
    return {

      sexArray: [
        {label: '不限', value: -1},
        {label: '男', value: 1},
        {label: '女', value: 2},
      ],
      sex: -1,


      statusArray: [
        {label: '不限', value: -1},
        {label: '待审核', value: 1},
        {label: '已通过', value: 2},
        {label: '不通过', value: 3}
      ],
      status: 1,

      // 发布状态
      overallAuthStateArray: [
        {label: '不限', value: -1},
        {label: '未提交', value: 0},
        {label: '待审核', value: 1},
        {label: '审核通过', value: 2},
        {label: '审核不通过', value: 3}
      ],
      overallAuthState: 2,

      // 优质状态
      recommendArray: [
        {label: '不限', value: -1},
        {label: '未推荐', value: 0},
        {label: '已推荐', value: 1}
      ],
      recommend: -1,

      //新人展示状态
      newUserShowArray: [
        {label: '不限', value: -1},
        {label: '已隐藏', value: 0},
        {label: '已展示', value: 1}
      ],
      newUserShow: -1,

      //关注类型
      focusStateArray: [
        {label: '不限', value: -1},
        {label: '未关注', value: 0},
        {label: '关注中', value: 1}
      ],
      focusState: -1,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['时间', '头像', '用户信息', '身份认证总状态', '达人状态', '推荐状态', '新人展示', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      updateReLoading: false,
      updateNewLoading: false,
      updateFocusLoading: false,

      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },

    // getExpireTime(val) {
    //   this.startExpire = val[0];
    //   this.endExpire = val[1];
    //   // console.log(val)
    // },
    //
    // getExpireCheck(val) {
    //   this.isExpireChecked = val
    // },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.status = 1;
      this.overallAuthState = 2;
      this.recommend = -1;
      this.newUserShow = -1;
      this.focusState = -1;
      this.sex = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['status'] = this.status;
      param['overallAuthState'] = this.overallAuthState;
      param['recommend'] = this.recommend;
      param['newUserShow'] = this.newUserShow;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      param['searchType'] = this.searchType;
      param['focusState'] = this.focusState;
      param['sex'] = this.sex;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getApplyPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

    },

    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },



    batchUpdate(state) {
      if(this.idArray.length > 0) {
        let _title = (state == 2?'通过':'不通过') + '后的小助手通知内容：'
        let _this = this
        Dialog.open({
          title: _title,
          component: UpdateApplyStateDialog,
          data: {
            idArray: this.idArray,
            state: state,
            width: '500px',
          },
          confirm: (()=>{
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }
          })
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一个用户进行操作',
          type: 'warning'
        })
      }
    },

    //批量更新达人的推荐
    batchUpdateRe(state) {
      if(this.idArray.length ==0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        });
        return;
      }
      this.$confirm('确认批量' + (state == 0?'【取消】':'【开启】')+'推荐状态').then(()=>{
        this.updateReLoading = true;
        let _this = this;
        let param = {};
        param['idArr'] = this.idArray;
        param['recommend'] = state;
        postFormData(updateApplyRecommend, param).then(function(data){
          let {code, msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            // _this.getPage();
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.updateReLoading = false;
        })
            .catch(function(response){
              _this.updateReLoading = false;
            })
      })
          .catch(() => {})
    },

    //新人展示状态
    batchUpdateNew(state) {
      if(this.idArray.length ==0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        });
        return;
      }
      this.$confirm('确认批量' + (state == 0?'【隐藏】':'【开启】')+'新人展示状态').then(()=>{
        this.updateNewLoading = true;
        let _this = this;
        let param = {};
        param['idArr'] = this.idArray;
        param['newUserShow'] = state;
        postFormData(updateApplyNewUserShow, param).then(function(data){
          let {code, msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            // _this.getPage();
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.updateNewLoading = false;
        })
            .catch(function(response){
              _this.updateNewLoading = false;
            })
      })
          .catch(() => {})
    },

    //新人展示状态
    batchUpdateFocus(state) {
      if(this.idArray.length ==0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行操作',
          type: 'warning'
        });
        return;
      }
      this.$confirm('确认批量' + (state == 0?'【取消】':'【设为】')+'关注状态').then(()=>{
        this.updateFocusLoading = true;
        let _this = this;
        let param = {};
        param['idArr'] = this.idArray;
        param['focusState'] = state;
        postFormData(updateTalentFcousState, param).then(function(data){
          let {code, msg} = data;
          if(code == 200){
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            // _this.getPage();
            for(let j=0;j<_this.idArray.length;j++){
              for(let i=0;i<_this.pageDataList.length;i++) {
                if(_this.pageDataList[i]['userId'] == _this.idArray[j]) {
                  _this.pageDataList.splice(i,1);
                  i--;
                }
              }
            }
            if(_this.pageDataList.length == 0){
              _this.getPage();
            }
          }else{
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          _this.updateFocusLoading = false;
        })
            .catch(function(response){
              _this.updateFocusLoading = false;
            })
      })
          .catch(() => {})
    },

    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: ApplySearchInfoDialog,
        data: {
          userForm: e,
          width: '500px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
